/**
 * A57 · utilidades de carrito compartidas por "Completa tu dúo" (PDP) y el upsell del carrito.
 * Agrega uno o varios artículos con el mismo flujo del tema (sections + CartAddEvent),
 * así el drawer se abre y se refresca solo.
 *
 * Uso declarativo: <button data-a57-add data-items='[{"id":123,"quantity":1}]' data-product-id="…">
 */
import { CartAddEvent } from '@theme/events';
import { fetchConfig } from '@theme/utilities';

const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

export async function a57AddItems(items, sourceId = 'a57', productId = '') {
  const fd = new FormData();
  for (const it of items) {
    fd.append('items[][id]', String(it.id));
    fd.append('items[][quantity]', String(it.quantity || 1));
  }
  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);
  if (sectionIds.length) fd.append('sections', sectionIds.join(','));

  const cfg = fetchConfig('javascript', { body: fd });
  const res = await fetch(`${ROOT}cart/add.js`, { ...cfg, headers: { ...cfg.headers, Accept: 'text/html' } });
  const json = await res.json();
  if (json.status) throw new Error(json.description || json.message || 'No se pudo agregar');

  const cart = await fetch(`${ROOT}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
  document.dispatchEvent(
    new CartAddEvent(cart, sourceId, {
      source: sourceId,
      itemCount: items.reduce((n, it) => n + (it.quantity || 1), 0),
      productId,
      sections: json.sections,
    })
  );
  const drawer = document.querySelector('cart-drawer-component');
  if (drawer && typeof drawer.open === 'function') drawer.open();
  return cart;
}

document.addEventListener('click', async (e) => {
  const btn = e.target instanceof Element ? e.target.closest('[data-a57-add]') : null;
  if (!btn || btn.hasAttribute('disabled')) return;
  e.preventDefault();
  let items = [];
  try {
    items = JSON.parse(btn.getAttribute('data-items') || '[]');
  } catch (_) {
    return;
  }
  if (!items.length) return;
  const label = btn.textContent;
  btn.setAttribute('disabled', '');
  btn.textContent = 'Agregando…';
  try {
    await a57AddItems(items, btn.getAttribute('data-source') || 'a57', btn.getAttribute('data-product-id') || '');
    btn.textContent = '¡Agregado!';
    setTimeout(() => {
      btn.textContent = label;
      btn.removeAttribute('disabled');
    }, 1800);
  } catch (err) {
    btn.textContent = 'No se pudo agregar';
    setTimeout(() => {
      btn.textContent = label;
      btn.removeAttribute('disabled');
    }, 2200);
  }
});

/**
 * Botón "Agregar" de las tarjetas de las 6 barras (form propio, ver snippets/a57-card-info.liquid).
 * Con JS agrega por fetch y abre el cajón sin recargar; sin JS el form envía a /cart/add y va al carrito.
 */
document.addEventListener('submit', async (e) => {
  const form = e.target instanceof Element ? e.target.closest('form[data-a57-card-add]') : null;
  if (!form) return;
  e.preventDefault();
  e.stopPropagation();
  const btn = form.querySelector('button[type="submit"]');
  if (btn && btn.hasAttribute('disabled')) return;
  const id = form.querySelector('input[name="id"]')?.value;
  if (!id) return;
  const label = btn ? btn.textContent : '';
  if (btn) { btn.setAttribute('disabled', ''); btn.textContent = 'Agregando…'; }
  try {
    await a57AddItems([{ id, quantity: 1 }], 'a57-card', form.getAttribute('data-product-id') || '');
    if (btn) btn.textContent = '¡Agregado!';
  } catch (err) {
    if (btn) btn.textContent = 'No se pudo agregar';
  }
  setTimeout(() => { if (btn) { btn.textContent = label; btn.removeAttribute('disabled'); } }, 1800);
});
